import { USERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import usersTypes from '../../constants/usersTypes'
import { axios } from '../../services'

//  lock AND unlock AND resend

const lock_user_request = () => {
  return {
    type: usersTypes.lock.request
  }
}

const lock_user_success = (response) => {
  return {
    type: usersTypes.lock.success,
    payload: response.data
  }
}

const lock_single_user_success = (response) => {
  return {
    type: usersTypes.lock.single,
    payload: response.data
  }
}

const lock_user_failure = (messages) => {
  return {
    type: usersTypes.lock.failure,
    payload: messages
  }
}

const lock_user = (user_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( lock_user_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(USERS_ROUTES.lock, {id: user_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The user status has changed to: Blocked.')
      if ( index ) {
        dispatch( lock_user_success(response) )

      } else {
        dispatch( lock_single_user_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error locking user"]
        // errors = [error]
      }
      dispatch( lock_user_failure( errors ) )
    })
  }
}

const unlock_user = (user_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( lock_user_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(USERS_ROUTES.unlock, {id: user_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The user status has changed to: Active.')
      if ( index ) {
        dispatch( lock_user_success(response) )

      } else {
        dispatch( lock_single_user_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        // errors = [error]
        errors = ["Error unlocking user"]
      }
      dispatch( lock_user_failure( errors ) )
    })
  }
}

const resend_invitation = (user_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( lock_user_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(USERS_ROUTES.resend, {id: user_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'A new invitation has been sent.')
      if ( index ) {
        dispatch( lock_user_success(response) )

      } else {
        dispatch( lock_single_user_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        // errors = [error]
        errors = ["Error resending user invitation"]
      }
      dispatch( lock_user_failure( errors ) )
    })
  }
}

export {
  lock_user,
  unlock_user,
  resend_invitation,
}



// WEBPACK FOOTER //
// ./src/js/actions/users/lock.js